<template>
  <div class="setComponent">
    <!-- 表单 -->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="form-setting" size="medium">
      <el-form-item :label="$i18n.t('wm_lang_870802')" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_7854b5')" prop="ruleStatus">
        <el-switch v-model="ruleStatus"></el-switch>
      </el-form-item>
      <!-- 步骤1 -->
      <div class="title">
        <h4>{{$t("wm_lang_html_52b365")}}1{{$t("wm_lang_html_528e20")}}</h4>
        <el-divider></el-divider>
      </div>
      <el-alert style="margin:15px 0;" :title="$i18n.t('wm_lang_23b8db')+' '+ $i18n.t('wm_lang_dec892')+' '+ $i18n.t('wm_lang_f12e4a')" :closable="false" type="info"></el-alert>
      <el-form-item prop="ruleFormFromMember">
        <label slot="label" class="flexBetween pl50"><el-checkbox v-model="ruleForm.fromEnable"></el-checkbox>{{$t("wm_lang_html_88c952")}}</label>
        <el-select v-model="ruleForm.fromInclude" :placeholder="$i18n.t('wm_lang_708c9d')">
          <el-option :label="$i18n.t('wm_lang_3ffa1d')" :value="true"></el-option>
          <el-option :label="$i18n.t('wm_lang_331b7f')" :value="false"></el-option>
        </el-select>
        <el-input v-model="ruleFormFromMember" :placeholder="$i18n.t('wm_lang_3d99b6')"></el-input>
        <input type="hidden" v-model="ruleForm.fromMember">
        <el-button type="primary" @click="dialogAddress('from')">{{$t("wm_lang_html_183abe")}}</el-button>
        <span
          slot="error"
          slot-scope="scope"
          class="el-form-item__error"
          style="left: 286px;"
        >{{ scope.error }}</span>
      </el-form-item>
      <el-form-item prop="ruleFormToMember">
        <label slot="label" class="flexBetween pl50"><el-checkbox v-model="ruleForm.toEnable"></el-checkbox>{{$t("wm_lang_html_fb5bf1")}}</label>
        <el-select v-model="ruleForm.toInclude" :placeholder="$i18n.t('wm_lang_708c9d')">
          <el-option :label="$i18n.t('wm_lang_3ffa1d')" :value="true"></el-option>
          <el-option :label="$i18n.t('wm_lang_331b7f')" :value="false"></el-option>
        </el-select>
        <el-input v-model="ruleFormToMember" :placeholder="$i18n.t('wm_lang_3d99b6')"></el-input>
        <input type="hidden" v-model="ruleForm.toMember">
        <el-button type="primary" @click="dialogAddress('to')">{{$t("wm_lang_html_183abe")}}</el-button>
        <span
          slot="error"
          slot-scope="scope"
          class="el-form-item__error"
          style="left: 286px;"
        >{{ scope.error }}</span>
      </el-form-item>
      <el-form-item prop="select">
        <label slot="label" class="flexBetween pl50"><el-checkbox v-model="ruleForm.subjectEnable"></el-checkbox>{{$t("wm_lang_html_1501d5")}}</label>
        <el-select v-model="ruleForm.subjectInclude" :placeholder="$i18n.t('wm_lang_708c9d')">
          <el-option :label="$i18n.t('wm_lang_3ffa1d')" :value="true"></el-option>
          <el-option :label="$i18n.t('wm_lang_331b7f')" :value="false"></el-option>
        </el-select>
        <el-input v-model="ruleFormSubjectVal" :placeholder="$i18n.t('wm_lang_f90387')"></el-input>
        <input type="hidden" v-model="ruleForm.subjectVal">
        <span
          slot="error"
          slot-scope="scope"
          class="el-form-item__error"
          style="left: 286px;"
        >{{ scope.error }}</span>
      </el-form-item>
      <el-form-item prop="mailSize">
        <label slot="label" class="flexBetween pl50"><el-checkbox v-model="ruleForm.mailSizeEnable"></el-checkbox>{{$t("wm_lang_html_f6ccd0")}}</label>
        <el-select v-model="mailSizeRegion" @change="changeMailSize" :placeholder="$i18n.t('wm_lang_708c9d')">
          <el-option :label="$i18n.t('wm_lang_a1d1e5')" :value="1"></el-option>
          <el-option :label="$i18n.t('wm_lang_1ec4aa')" :value="2"></el-option>
          <el-option :label="$i18n.t('wm_lang_43ef05')" :value="3"></el-option>
        </el-select>
        <span v-show="mailSizeRegion === 1"><el-input ref="sizeMin" v-model="ruleForm.mailSizeMin"></el-input><span>KB</span></span>
        <span v-show="mailSizeRegion === 2"><el-input ref="sizeMax" v-model="ruleForm.mailSizeMax"></el-input><span>KB</span></span>
        <span v-show="mailSizeRegion === 3"><el-input ref="sizeRegion" v-model="ruleForm.mailSizeMin" style="width:113px;margin-right:5px;"></el-input><span>KB</span>&nbsp;&nbsp;-&nbsp;&nbsp;<el-input v-model="ruleForm.mailSizeMax" style="width:113px;margin-right:5px;"></el-input><span>KB</span></span>
        <span
          slot="error"
          slot-scope="scope"
          class="el-form-item__error"
          :style="{
            left: mailSizeRegion === 3 ? '286px' : '286px'
          }"
        >{{ scope.error }}</span>
      </el-form-item>

      <br><br>

      <!-- 步骤2 -->
      <div class="title">
        <h4>{{$t("wm_lang_html_52b365")}}2{{$t("wm_lang_html_89da89")}}</h4>
        <el-divider></el-divider>
      </div>
      <el-alert style="margin:15px 0;" :title="$i18n.t('wm_lang_d0a548')" :closable="false" type="info"></el-alert>
      <el-form-item label="" prop="radio">
        <el-radio-group v-model="executeOptOrDelete">
          <el-radio :label="true">{{$t("wm_lang_html_6afaf4")}}</el-radio>
          <el-radio :label="false">{{$t("wm_lang_html_536d2c")}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="" prop="select">
        <el-checkbox :label="$i18n.t('wm_lang_188e4b')" v-model="ruleForm.moveFolderEnable" name="type" :disabled="!executeOptOrDelete"></el-checkbox>
        <el-select v-model="ruleForm.moveFolderId" :placeholder="$i18n.t('wm_lang_708c9d')" :disabled="!executeOptOrDelete" class="ml5">
          <el-option v-for="(item, index) in folders" :key="index" :label="item.displayName" :value="item.folderId" style="max-width:274px;"></el-option>
          <el-option value="" style="border-top: 1px solid #EBEEF5;">
            <div @click="createNewFolder($event)">{{$t("wm_lang_html_f3a485")}}</div>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" prop="select">
        <el-checkbox :label="$i18n.t('wm_lang_35c8ad')" v-model="ruleForm.forwardEnable" name="type" :disabled="!executeOptOrDelete || deliverForwardDisable"></el-checkbox>
        <br>
        <el-input type="textarea" rows="5" @blur="verifyAddr" v-model="ruleFormForwardAddr" :placeholder="$i18n.t('wm_lang_f30bfb')" :disabled="!executeOptOrDelete || deliverForwardDisable"></el-input>
        <span v-if="executeOptOrDelete && !forwardAddrVaild" class="c_red">{{$t("wm_lang_html_a6c60b")}}:name@example.com</span>
        <span v-if="executeOptOrDelete && forwardAddrVaildOver" class="c_red">{{$t("wm_lang_html_83aa19")}}{{this.forwardAddrMax}}{{$t("wm_lang_html_930882")}}</span>
        <input type="hidden" v-model="ruleForm.forwardAddr">
        <div label="" prop="radio">
          <el-radio-group v-model="ruleForm.forwardDiscardEnable" :disabled="!executeOptOrDelete || deliverForwardDisable">
            <el-radio :label="false">{{$t("wm_lang_html_400521")}}</el-radio>
            <el-radio :label="true">{{$t("wm_lang_html_01cd93")}}</el-radio>
          </el-radio-group>
        </div>
        <span v-show="deliverForwardDisable" class="c_red">({{$t("wm_lang_html_ae2e1f")}})</span>
        <span v-show="deliverForwardForeign" class="c_red">({{$t("wm_lang_html_0b543c")}})</span>
      </el-form-item>
      <el-form-item label="" prop="select">
        <el-checkbox :label="$i18n.t('wm_lang_922a77')" v-model="ruleForm.replyEnable" name="type" :disabled="!executeOptOrDelete"></el-checkbox>
        <br>
        <el-input type="textarea" rows="5" v-model="ruleForm.replyContent" placeholder="" :disabled="!executeOptOrDelete"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">{{$t("wm_lang_html_be5fbb")}}</el-button>
        <el-button @click="cancelForm">{{$t("wm_lang_html_625fb2")}}</el-button>
      </el-form-item>
    </el-form>
    <br><br>
    <!-- 新建文件夹模态框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="520px">
      <el-form :model="ruleFolderForm" :rules="folderRules" ref="folderForm" class="form-setting">
        <el-form-item :label="$i18n.t('wm_lang_a98473')" prop="folderName" :label-width="formLabelWidth">
          <el-input v-model="ruleFolderForm.folderName" autocomplete="off" :placeholder="$i18n.t('wm_lang_5df03b')"></el-input>
        </el-form-item>
        <el-form-item :label="$i18n.t('wm_lang_22b234')" :label-width="formLabelWidth">
          <el-select v-model="belongFolder" :placeholder="$i18n.t('wm_lang_c2b9f4')" style="max-width:270px;">
            <el-option :label="$i18n.t('wm_lang_c2b9f4')" :value="0"></el-option>
            <el-option v-for="(item, index) in folders" :key="index" :label="item.displayName" :value="item.folderId" style="width:270px;"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">{{$t("wm_lang_html_55c3f6")}} {{$t("wm_lang_html_aa4d94")}}</el-button>
        <el-button type="primary" @click="addFolder('folderForm')">{{$t("wm_lang_html_2d7a2f")}} {{$t("wm_lang_html_a7a342")}}</el-button>
      </div>
    </el-dialog>
    <SelectAddressDialog ref="selectAddressDialog" v-model="selectAddressVisible" :getOrgTrees="getOrgTrees"
                         :getPersTrees="getPersTrees" :getMailAddress="getMailAddress"
                         :cancelAddressContact="cancelAddressContact"/>
  </div>
</template>

<script>
  import xmail from '@/api/api';
  import storeLocal from 'store';
  import SelectAddressDialog from '../../sub/selectAddressDialog.vue';
  import _ from "lodash";
  import { getFolderPathName } from '@/utils/utils';

  export default {
    name: 'addRules',
    data () {
      let mailSizeVerify = (rule, value, callback) => {
        // const reg = /^\+?[1-9][0-9]*$/;//正整数
        const reg=/^[0-9]+?$/;
        if(this.mailSizeRegion === 1) {
          if (!reg.test(this.ruleForm.mailSizeMin) && this.ruleForm.mailSizeMin !== '') {
            callback(new Error(this.$i18n.t('wm_lang_5e579b')));
          }
          else if (parseInt(this.ruleForm.mailSizeMin) > 2147483647) {
            callback(new Error(this.$i18n.t('wm_lang_5e579b')));
          }
          else {
            callback();
          }
        }
        if(this.mailSizeRegion === 2) {
          if (!reg.test(this.ruleForm.mailSizeMax) && this.ruleForm.mailSizeMax !== '') {
            callback(new Error(this.$i18n.t('wm_lang_5e579b')));
          }
          else if (parseInt(this.ruleForm.mailSizeMax) > 2147483647) {
            callback(new Error(this.$i18n.t('wm_lang_5e579b')));
          }
          else {
            callback();
          }
        }
        if(this.mailSizeRegion === 3) {
          if ( (!reg.test(this.ruleForm.mailSizeMin) && this.ruleForm.mailSizeMin !== '')
            || (!reg.test(this.ruleForm.mailSizeMax) && this.ruleForm.mailSizeMax !== '') ) {
            callback(new Error(this.$i18n.t('wm_lang_5e579b')));
          }
          else if (parseInt(this.ruleForm.mailSizeMin) > 2147483647 || parseInt(this.ruleForm.mailSizeMax) > 2147483647) {
            callback(new Error(this.$i18n.t('wm_lang_5e579b')));
          }
          else if (parseInt(this.ruleForm.mailSizeMin) >= parseInt(this.ruleForm.mailSizeMax)) {
            callback(new Error(this.$i18n.t('wm_lang_e11f7c')));
          }
          else {
            callback();
          }
        }
      };
      let ruleFormFromMemberVerify = (rule, value, callback) => {
        if(!this.ruleFormFromMember) {
          callback();
        }
        let regEmail=/^[a-z0-9]+([-_.]\w+)*@[\w-]+(\.[\w-]+)+$/;
        let regDomain = /^[\w-]+(\.[\w-]+)+$/;
        let fromMembers = this.ruleFormFromMember.split(',');
        let fromMembersFlag = true;
        let isNull = false;
        fromMembers.forEach(item => {
          if(!item) {
            isNull = true;
          }
          if(!regEmail.test(item) && !regDomain.test(item)){
            fromMembersFlag = false;
            return false;
          }
        });
        if(fromMembers.length > this.filterMemberMax && !isNull) {
          callback(new Error(`${this.$i18n.t('custom_lang_0084')}${this.filterMemberMax}`));
        }
        if(!fromMembersFlag){
          callback(new Error(this.$i18n.t('wm_lang_f41cf0')));
        } else {
          callback();
        }
      };
      let ruleFormToMemberVerify = (rule, value, callback) => {
        if(!this.ruleFormToMember) {
          callback();
        }
        let regEmail=/^[a-z0-9]+([-_.]\w+)*@[\w-]+(\.[\w-]+)+$/;
        let regDomain = /^[\w-]+(\.[\w-]+)+$/;
        let toMembers = this.ruleFormToMember.split(',');
        let toMembersFlag = true;
        let isNull = false;
        toMembers.forEach(item => {
          if(!item) {
            isNull = true;
          }
          if(!regEmail.test(item) && !regDomain.test(item)){
            toMembersFlag = false;
            return false;
          }
        });
        if(toMembers.length > this.filterMemberMax && !isNull) {
          callback(new Error(`${this.$i18n.t('custom_lang_0084')}${this.filterMemberMax}`));
        }
        if(!toMembersFlag){
          callback(new Error(this.$i18n.t('wm_lang_f41cf0')));
        } else {
          callback();
        }
      };
      let folderNameVerify = (rule, value, callback) => {
        let reg = /[\/\:\*\?\"\<\>\|\ \\\+\']+/g;
        if (value.match(reg)) {
          callback(new Error(this.$i18n.t('wm_lang_6f67c4')+"\\ \/ \: \* \? \" \< \> \| \+ \' "+ this.$i18n.t('wm_lang_html_fcbc6a')));
        } else {
          //
          callback();
        }
      };
      let configSetting = storeLocal.get('Pwm-configSetting');
      return {
        selectAddressVisible: false,
        dialogAddressTarget: 'from',
        deliverForwardDisable: false,
        deliverForwardForeign: false,
        orgTrees: [],
        persTrees: [],
        ruleStatus: true,
        executeOptOrDelete: true,
        ruleFormFromMember: '',
        ruleFormToMember: '',
        ruleFormFromMemberObj: {},
        ruleFormToMemberObj: {},
        ruleFormForwardAddr: '',
        ruleFormSubjectVal: '',
        forwardAddrVaild: true,
        forwardAddrVaildOver: false,
        mailSizeRegion: 1,
        filterMemberMax: 100,
        forwardAddrMax: 100,
        folders: [],
        dialogTitle: this.$i18n.t('wm_lang_f3a485'),
        ruleFolderForm: {
          folderName: ''
        },
        belongFolder: 0,
        dialogFormVisible: false,
        formLabelWidth: '140px',
        // 表单
        ruleForm: {
          filterId: "",
          status: this.ruleStatus ? xmail.enums.AccountFilterRuleStatus.ENABLE : xmail.enums.AccountFilterRuleStatus.DISABLE,
          name: "",
          fromEnable: false,
          fromInclude: true,
          fromMember: [],
          subjectEnable: false,
          subjectInclude: true,
          subjectMatchAll: true,
          subjectVal: [],
          mailSizeEnable: false,
          mailSizeMax: '',
          mailSizeMin: '',
          executeOptType: this.executeOptOrDelete ? xmail.enums.FilterExecuteOptType.RUN : xmail.enums.FilterExecuteOptType.DELETE,
          moveFolderEnable: false,
          moveFolderId: 1,
          forwardEnable: false,
          forwardAddr: [],
          forwardDiscardEnable: false,
          replyEnable: false,
          replyContent: "",
          toEnable: false,
          toInclude: true,
          toMember: [],
        },
        rules: {
          name: [
            { required: true, message: this.$i18n.t('wm_lang_6ed179') },
            { min: 2, max: 64, message: this.$i18n.t('wm_lang_669656')+'2'+this.$i18n.t('wm_lang_40ff1a')+'64'+this.$i18n.t('wm_lang_cf10dc'), trigger: 'blur' }
          ],
          mailSize: [
            { validator: mailSizeVerify, trigger: 'blur' }
          ],
          ruleFormFromMember: [
            { validator: ruleFormFromMemberVerify, trigger: ['blur', 'change'] }
          ],
          ruleFormToMember: [
            { validator: ruleFormToMemberVerify, trigger: ['blur', 'change'] }
          ]
        },
        folderRules:{
          folderName: [
            { required: true, message: this.$i18n.t('wm_lang_47631c'), trigger: 'blur' },
            { max: configSetting.globalConfig.fieldLengthLimit.folderLimit.folderName,
              message: `${this.$i18n.t('wm_lang_379b24')}${configSetting.globalConfig.fieldLengthLimit.folderLimit.folderName}${this.$i18n.t('wm_lang_15d410')}`,
              trigger: 'blur' },
            { validator: folderNameVerify, trigger: 'blur' }
            // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: this.$i18n.t('wm_lang_e10150'), trigger: 'blur' }
          ]
        }
      }
    },
    components:{
      SelectAddressDialog
    },
    mounted() {
      this.localConfigSetting = storeLocal.get('Pwm-configSetting');
      this.deliverForwardDisable = this.localConfigSetting.deliverSetting.forwardType === xmail.enums.RoleDeliverForwardType.DISABLE;
      this.deliverForwardForeign = this.localConfigSetting.deliverSetting.forwardType === xmail.enums.RoleDeliverForwardType.DISABLE_FOREIGN;
      this.filterMemberMax = this.localConfigSetting.globalConfig.maximumLimit.filterMemberMax;
      this.forwardAddrMax = this.localConfigSetting.globalConfig.maximumLimit.forwardAddrMax;
      this.getFolders();
      let ruleId = this.$route.params.id;
      if(ruleId) {
        let self = this;
        (function (api, enums, pms) {
          let pm = pms.Filter.queryFilterInfoParamBuilder();
          pm.filterId = ruleId;
          api.Filter.queryFilterInfo(pm, function (res) {
            if(res.data.code === 0) {
              self.ruleForm = res.data.data;
              self.executeOptOrDelete = self.ruleForm.executeOptType === enums.FilterExecuteOptType.RUN;
              self.ruleStatus = self.ruleForm.status === xmail.enums.AccountFilterRuleStatus.ENABLE;
              self.ruleFormFromMember = self.ruleForm.fromMember.toString();
              self.ruleFormToMember = self.ruleForm.toMember.toString();
              self.ruleFormForwardAddr = self.ruleForm.forwardAddr.toString();
              self.ruleFormSubjectVal = self.ruleForm.subjectVal.toString();
              if (self.ruleForm.mailSizeMax === 2147483647) {
                self.ruleForm.mailSizeMax = ''
                self.mailSizeRegion = 1;
              }
              if (self.ruleForm.mailSizeMin === -1) {
                self.ruleForm.mailSizeMin = ''
                self.mailSizeRegion = 2;
              }
              if (self.ruleForm.mailSizeMax !== '' && self.ruleForm.mailSizeMin !== '') {
                self.mailSizeRegion = 3;
              }
            }
          })
        })(xmail.api, xmail.enums, xmail.pms);
      }
    },
    methods: {
      dialogAddress(targ) {
        this.dialogAddressTarget = targ;
        this.setFromMemberMailAddress();
        let addrs = (targ === 'from') ? this.ruleForm.fromMember : this.ruleForm.toMember;
        let addrsObj = (targ === 'from') ? this.ruleFormFromMemberObj : this.ruleFormToMemberObj
        let address = [];
        addrs.forEach((email) => {
          if(email) {
            address.push({name: addrsObj[email] ? addrsObj[email] : email.substr(0, email.indexOf('@')), email});
          }
        })
        this.$refs.selectAddressDialog.selectedRcpts.address = address;
        this.selectAddressVisible = true;
      },
      setFromMemberMailAddress() {
        if (this.ruleFormFromMember !== '') {
          this.ruleForm.fromMember = this.ruleFormFromMember.split(',');
        } else {
          this.ruleForm.fromMember = [];
        }
        if (this.ruleFormToMember !== '') {
          this.ruleForm.toMember = this.ruleFormToMember.split(',');
        } else {
          this.ruleForm.toMember = [];
        }
      },
      getOrgTrees(nodes) {
        this.orgTrees = nodes;
      },
      getPersTrees(nodes) {
        this.persTrees = nodes;
      },
      cancelAddressContact() {
        this.selectAddressVisible = false;
      },
      resetForm() {
        this.dialogFormVisible = false
        this.ruleFolderForm.folderName = '';
      },
      changeMailSize(val) {
        this.ruleForm.mailSizeMin = '';
        this.ruleForm.mailSizeMax = '';
        if(val === 1) {
          this.$nextTick(() => {
            this.$refs.sizeMin.focus();
          })
        }
        if(val === 2) {
          this.$nextTick(() => {
            this.$refs.sizeMax.focus();
          })
        }
        if(val === 3) {
          this.$nextTick(() => {
            this.$refs.sizeRegion.focus();
          })
        }
      },
      createNewFolder(e) {
        e.stopPropagation();
        e.preventDefault();
        this.dialogFormVisible = true;
      },
      verifyAddr() {
        if(this.ruleFormForwardAddr) {
          const addrList = this.ruleFormForwardAddr.split(',');
          addrList.forEach((item) => {
            let regEmail=/^[a-z0-9]+([-_.]\w+)*@[\w-]+(\.[\w-]+)+$/;
            if(!regEmail.test(item)){
              this.forwardAddrVaild = false;
            } else {
              this.forwardAddrVaild = true;
            }
          });
          if(addrList.length > this.forwardAddrMax) {
            this.forwardAddrVaildOver = true;
          } else {
            this.forwardAddrVaildOver = false;
          }
        }
        else {
          this.forwardAddrVaildOver = false;
          this.forwardAddrVaild = true;
        }
      },
      getMailAddress(addressData) {
        console.log(addressData)
        let addrArr = []
        let addrObj = {}
        addressData.address.forEach((item,index)=>{
          addrArr.push(item.email);
          addrObj[item.email] = item.name;
        })
        if(this.dialogAddressTarget === 'from') {
          // this.ruleForm.fromMember = addrArr;  无用
          this.ruleFormFromMember = _.uniq(addrArr).toString();
          this.ruleFormFromMemberObj = addrObj;
        } else {
          // this.ruleForm.toMember = addrArr;
          this.ruleFormToMember =  _.uniq(addrArr).toString();
          this.ruleFormToMemberObj = addrObj;
        }
        console.log(this.ruleForm.fromMember)
      },
      getFolders() {
        let self = this;
        let localFolders = self.$store.getters.folders;
        if(localFolders) {
          self.folders = self.$store.getters.folders;
          self.folders = self.folders.filter(item => item.folderId !== xmail.enums.FolderType.STAR_BOX_FOLDER_ID && item.folderId !== xmail.enums.FolderType.WAITING_BOX_FOLDER_ID)
          self.folders = getFolderPathName(self.folders);
          return;
        }
        (function (api, enums, pms) {
          api.Folder.getFolderList({}, function (res) {
            const list = res.data.data.mailFolders;
            self.$store.commit('SET_FOLDERS',list);
            self.folders = self.$store.getters.folders;
            self.folders = self.folders.filter(item => item.folderId !== enums.FolderType.STAR_BOX_FOLDER_ID && item.folderId !== enums.FolderType.WAITING_BOX_FOLDER_ID && item.folderId !== enums.FolderType.BACKUP_BOX_FOLDER_ID)
            self.folders = getFolderPathName(self.folders);
          })
        })(xmail.api, xmail.enums, xmail.pms);
      },
      cancelForm() {
        this.$router.push({name: 'classificationRules'});
      },
      submitForm(formName) {
        if (this.executeOptOrDelete) {
          if (!this.ruleForm.moveFolderEnable && !this.ruleForm.forwardEnable && !this.ruleForm.replyEnable) {
            this.$message({
              type: 'warning',
              message: this.$i18n.t('wm_lang_14b860')
            })
            return;
          }
        } else if (!this.forwardAddrVaild) {
          this.forwardAddrVaild = true;
          this.ruleFormForwardAddr = '';
        }
        if ((this.ruleForm.forwardEnable || this.ruleFormForwardAddr) && !this.forwardAddrVaild) {
          this.$message({
            type: 'warning',
            message: this.$i18n.t('wm_lang_6fc9ce')
          });
          return;
        }
        if (this.executeOptOrDelete && this.ruleForm.forwardEnable && this.ruleFormForwardAddr == '') {
          this.$message({
            type: 'warning',
            message: this.$i18n.t('wm_lang_ca2153')
          });
          return;
        }
        else if(this.ruleForm.forwardEnable) {
          const addrList = this.ruleFormForwardAddr.split(',');
          const addrListReplica = _.uniq(addrList);
          if (addrList.length != addrListReplica.length) {
              this.$message({
              type: 'warning',
              message: this.$i18n.t('wm_lang_d69797')
            });
            return;
          }
        }
        if (this.executeOptOrDelete && this.ruleForm.replyEnable && this.ruleForm.replyContent == '') {
          this.$message({
            type: 'warning',
            message: this.$i18n.t('wm_lang_ace6d1')
          });
          return;
        }
        if(this.ruleForm.mailSizeEnable) {
          if(this.mailSizeRegion === 1) {
            if(this.ruleForm.mailSizeMin === '') {
              this.$message({
                type: 'warning',
                message: this.$i18n.t('wm_lang_8572ea')
              });
              return;
            }
          }
          if(this.mailSizeRegion === 2) {
            if(this.ruleForm.mailSizeMax === '') {
              this.$message({
                type: 'warning',
                message: this.$i18n.t('wm_lang_9b3884')
              });
              return;
            }
          }
          if(this.mailSizeRegion === 3) {
            if (this.ruleForm.mailSizeMin === '' || parseInt(this.ruleForm.mailSizeMin, 10) < 0) {
              this.$message({
                type: 'warning',
                message: this.$i18n.t('wm_lang_1e9b8e')
              });
              return;
            }
            if (this.ruleForm.mailSizeMax === '' || parseInt(this.ruleForm.mailSizeMax, 10) < 0) {
              this.$message({
                type: 'warning',
                message: this.$i18n.t('wm_lang_cdd051')
              });
              return;
            }
            if (parseInt(this.ruleForm.mailSizeMax, 10) < parseInt(this.ruleForm.mailSizeMin, 10)) {
              this.$message({
                type: 'warning',
                message: this.$i18n.t('wm_lang_e5a33f')
              });
              return;
            }
          }
        }
        if(this.ruleFormFromMember.split(',').length > this.filterMemberMax) {
          this.$message({
            type: 'warning',
            message: `发件人地址上限${this.filterMemberMax}个`
          });
          return;
        }
        if(this.ruleFormToMember.split(',').length > this.filterMemberMax) {
          this.$message({
            type: 'warning',
            message: `收件人地址上限${this.filterMemberMax}个`
          });
          return;
        }
        if(this.ruleFormForwardAddr.split(',').length > this.forwardAddrMax) {
          this.$message({
            type: 'warning',
            message: `自动转发地址上限${this.forwardAddrMax}个`
          });
          return;
        }
        if(this.ruleForm.subjectEnable && this.ruleFormSubjectVal.length > 1024) {
          this.$message({
            type: 'warning',
            message: this.$i18n.t('wm_lang_437839')+'1024'
          });
          return;
        }
        // this.ruleForm.forwardEnable = this.ruleFormForwardAddr !== '';
        // this.ruleForm.replyEnable = this.ruleForm.replyContent !== '';
        this.$refs[formName].validate((valid) => {
          console.log(valid)
          if (valid) {
            let ruleId = this.$route.params.id;
            if(ruleId) {
              let self = this;
              (function (api, enums, pms) {
                // self.ruleForm.forwardAddr = self.ruleFormForwardAddr.replaceAll(',','§');
                self.ruleForm.forwardAddr =  self.ruleFormForwardAddr ? self.ruleFormForwardAddr.split(',') : [];
                // self.ruleForm.subjectVal = self.ruleForm.subjectVal.replaceAll(',','§');
                self.ruleForm.subjectVal = self.ruleFormSubjectVal ? self.ruleFormSubjectVal.split(',') : [];
                self.ruleForm.status = self.ruleStatus ? enums.AccountFilterRuleStatus.ENABLE : enums.AccountFilterRuleStatus.DISABLE;
                self.ruleForm.executeOptType = self.executeOptOrDelete ? enums.FilterExecuteOptType.RUN : enums.FilterExecuteOptType.DELETE;
                if(self.mailSizeRegion === 1) {
                  self.ruleForm.mailSizeMax = 2147483647;
                }
                if(self.mailSizeRegion === 2) {
                  self.ruleForm.mailSizeMin = -1;
                }
                self.setFromMemberMailAddress();
                if(!self.ruleForm.subjectEnable) {
                  self.ruleForm.subjectVal = [];
                }
                if(!self.ruleForm.mailSizeEnable) {
                  self.ruleForm.mailSizeMin = -1;
                  self.ruleForm.mailSizeMax = 2147483647;
                }
                let pm = {...self.ruleForm, ...{filterId: ruleId}};
                // console.log(pm)
                // return;
                api.Filter.updateFilterInfo(pm, function (res) {
                  if(res.data.code === 0) {
                    self.$message({
                      type: 'success',
                      message: self.$i18n.t('wm_lang_69be67')
                    });
                    self.$router.push({name: 'classificationRules'});
                  } else {
                    if(self.ruleForm.mailSizeMin === -1) {
                      self.ruleForm.mailSizeMin = '';
                    }
                    if(self.ruleForm.mailSizeMax === 2147483647) {
                      self.ruleForm.mailSizeMax = '';
                    }
                  }
                })
              })(xmail.api, xmail.enums, xmail.pms);
            } else {
              let self = this;
              (function (api, enums, pms) {
                // self.ruleForm.forwardAddr = self.ruleFormForwardAddr.replaceAll(',','§');
                self.ruleForm.forwardAddr = self.ruleFormForwardAddr ? self.ruleFormForwardAddr.split(',') : [];
                // self.ruleForm.subjectVal = self.ruleForm.subjectVal.replaceAll(',','§');
                self.ruleForm.subjectVal = self.ruleFormSubjectVal ? self.ruleFormSubjectVal.split(',') : [];
                self.ruleForm.status = self.ruleStatus ? enums.AccountFilterRuleStatus.ENABLE : enums.AccountFilterRuleStatus.DISABLE;
                self.ruleForm.executeOptType = self.executeOptOrDelete ? enums.FilterExecuteOptType.RUN : enums.FilterExecuteOptType.DELETE;
                if(self.mailSizeRegion === 1) {
                  self.ruleForm.mailSizeMax = 2147483647;
                }
                if(self.mailSizeRegion === 2) {
                  self.ruleForm.mailSizeMin = -1;
                }
                if(!self.ruleForm.fromEnable) {
                  self.ruleForm.fromMember = [];
                } else {
                  if(self.ruleFormFromMember !== '') {
                    self.ruleForm.fromMember = self.ruleFormFromMember.split(',');
                  } else {
                    self.ruleForm.fromMember = [];
                  }
                }
                if(!self.ruleForm.toEnable) {
                  self.ruleForm.toMember = [];
                } else {
                  if(self.ruleFormToMember !== '') {
                    self.ruleForm.toMember = self.ruleFormToMember.split(',');
                  } else {
                    self.ruleForm.toMember = [];
                  }
                }
                if(!self.ruleForm.subjectEnable) {
                  self.ruleForm.subjectVal = [];
                }
                if(!self.ruleForm.mailSizeEnable) {
                  self.ruleForm.mailSizeMin = -1;
                  self.ruleForm.mailSizeMax = 2147483647;
                }
                let pm = self.ruleForm;
                // console.log(pm)
                // return;
                api.Filter.addFilterInfo(pm, function (res) {
                  if(res.data.code === 0) {
                    self.$message({
                      type: 'success',
                      message: self.$i18n.t('wm_lang_3fdaea')
                    });
                    self.$router.push({name: 'classificationRules'});
                  } else {
                    if(self.ruleForm.mailSizeMin === -1) {
                      self.ruleForm.mailSizeMin = '';
                    }
                    if(self.ruleForm.mailSizeMax === 2147483647) {
                      self.ruleForm.mailSizeMax = '';
                    }
                  }
                })
              })(xmail.api, xmail.enums, xmail.pms);
            }

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      addFolder(formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            this.dialogFormVisible = false;
            let self = this;
            (function (api, enums, pms) {
              let pm = pms.Folder.addFolderParamBuilder();
              pm.name = self.ruleFolderForm.folderName;
              pm.parentFolderId = self.belongFolder;
              api.Folder.addFolder(pm, function (res) {
                if(res.data.code === 0) {
                  self.$store.commit('SET_FOLDERS',null);
                  self.getFolders();
                  self.$message({
                    type: 'success',
                    message: self.$i18n.t('wm_lang_3fdaea')+'!'
                  });
                }
              })
            })(xmail.api, xmail.enums, xmail.pms);
          }
        });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .setComponent{padding:10px;}
  .setComponent .title .el-divider--horizontal{margin:10px 0;}


</style>
<style scoped lang="scss">
/deep/.el-form-item.is-error .el-select .el-input__inner {
  border-color: #DCDFE6;
}
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/addRules.vue